const REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

function easeOutQuart(t) {
  const u = 1 - t;
  return 1 - u * u * u * u;
}

function animateCounter(el) {
  const target = parseFloat(el.dataset.to);
  const prefix = el.dataset.prefix ?? '';
  const suffix = el.dataset.suffix ?? '';
  const duration = 1400;

  if (REDUCED_MOTION) {
    el.textContent = prefix + target + suffix;
    return;
  }

  const start = performance.now();

  function tick(now) {
    const progress = Math.min((now - start) / duration, 1);
    el.textContent = prefix + Math.round(easeOutQuart(progress) * target) + suffix;
    if (progress < 1) requestAnimationFrame(tick);
  }

  requestAnimationFrame(tick);
}

export function init() {
  const counterObs = new IntersectionObserver(entries => {
    entries.forEach(e => {
      if (!e.isIntersecting) return;
      animateCounter(e.target);
      counterObs.unobserve(e.target);
    });
  }, { threshold: 0.6 });

  document.querySelectorAll('.metric-n[data-to]').forEach(el => counterObs.observe(el));
}
